import { Link } from "react-router-dom";
import { Gift, ArrowRight } from "lucide-react";
import { useT } from "@/lib/i18n";
import { useApi } from "@/lib/data";

export default function LaunchBanner({ cta = true }) {
  const { t, lp } = useT();
  const { data } = useApi("launch-offer", "/launch-offer");
  if (!data?.on || data.left === 0) return null;
  const body = (
    <>
      <Gift className="h-4 w-4 flex-shrink-0 text-saffron" />
      <span data-testid="launch-banner-title">{t("launch_title", { n: data.limit })}</span>
      {cta && <ArrowRight className="h-4 w-4 flex-shrink-0 text-saffron transition-transform group-hover:translate-x-0.5" />}
    </>
  );
  const cls = "group mx-5 my-3 flex items-center justify-center gap-2 rounded-xl bg-ink px-4 py-2.5 text-center text-[13px] font-bold leading-snug text-white sm:text-sm lg:mx-8 lg:mb-0";
  return cta
    ? <Link to={lp("/owner/new")} className={cls} data-testid="launch-banner">{body}</Link>
    : <div className={cls} data-testid="launch-banner">{body}</div>;
}
